/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
import type { OrganizationVideoResponse } from '../models/OrganizationVideoResponse';

export class OrganizationVideoService {
  /**
   * Get organization video URL
   * Returns a short-lived SAS URL to the selected organisation's video, if configured.
   * @param xSelectedOrganisationId
   * @returns OrganizationVideoResponse Video available
   * @throws ApiError
   */
  public static getOrganizationVideo(xSelectedOrganisationId: string): CancelablePromise<OrganizationVideoResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/organization/video',
      headers: {
        'X-Selected-Organisation-Id': xSelectedOrganisationId,
      },
      errors: {
        401: `Not authorized to see this content`,
        403: `User is not allowed for the selected organisation`,
        404: `No knowledge base video configured for this organisation`,
        500: `Some unexpected error occurred, probably caused by either a configuration error or a programming mistake. Please contact the development team!`,
      },
    });
  }
}
